import RenderHTML from "../../../../../../../components/ui-components/RenderHTML"

type IdealPlanManagerTrackRecordDisclaimerProps = {
  disclaimer: string
}

export function IdealPlanManagerTrackRecordDisclaimer({
  disclaimer
}: IdealPlanManagerTrackRecordDisclaimerProps) {
  return (
    <div className="flex items-start gap-3 px-5 pb-6 pt-4">
      <IdealPlanManagerTrackRecordIcon />
      <div className="text-[13px] font-[400] leading-[150%] text-[#232323] max-w-[253px]">{disclaimer}</div>
    </div>
  )
}

export function IdealPlanManagerTrackRecordIcon() {
  return (
    <RenderHTML innerHTMLText={`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 0.75C30.6315 0.75 39.25 9.36852 39.25 20C39.25 30.6315 30.6315 39.25 20 39.25C9.36852 39.25 0.75 30.6315 0.75 20C0.75 9.36852 9.36852 0.75 20 0.75Z" stroke="#F0F4F7" stroke-width="1.5"/>
<path d="M16.201 12.3281C15.1025 12.6687 14.3047 13.6928 14.3047 14.9033C14.3047 16.1137 15.1025 17.1378 16.201 17.4784" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.6019 17.6022C19.1131 17.6022 17.9062 16.3953 17.9062 14.9066C17.9062 13.4178 19.1131 12.2109 20.6019 12.2109C22.0906 12.2109 23.2975 13.4178 23.2975 14.9066C23.2975 16.3953 22.0906 17.6022 20.6019 17.6022Z" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M24.3381 21.1955C23.4598 20.0999 22.1103 19.3984 20.5969 19.3984C17.9502 19.3984 15.8047 21.544 15.8047 24.1906H18.7998" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.409 24.1903H12.2109C12.2109 22.3351 13.2651 20.7261 14.8071 19.9297" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M27.7821 21.7969L22.9899 27.7871L20.5938 25.9901" stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`} />
  )
}
